import React from "react";
import styles from "./list-item-section-scss.js";
const ListItemSection = ({ type }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.whitespace }, type === "divider" && /* @__PURE__ */ React.createElement("div", { className: styles.divider }));
};
var ListItemSection_default = ListItemSection;
export {
  ListItemSection_default as default
};
//# sourceMappingURL=ListItemSection.js.map
